:host {
  display: contents;

  @media print {
    display: none;
  }
}

.stzh-print {
  display: contents;
}
